import {
  Component,
  ViewChild,
  ViewEncapsulation,
  inject,
  signal,
} from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SidebarModule } from 'primeng/sidebar';
import {
  MenuService,
  SidebarMenuItem,
} from '../../../core/services/menu.service';
import { GlobalButtonComponent, MenuItemComponent } from 'declarabid-library';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../features/auth/services/auth.service';
import { UserRole } from '../../../core/models/auth.model';
import { UsersService } from '../../../features/users/services/users.service';
import { OverlayPanelModule, OverlayPanel } from 'primeng/overlaypanel';
import { OverlayNotificationsComponent } from '../overlay-notifications/overlay-notifications.component';

@Component({
  selector: 'app-navigation-bar-movil',
  standalone: true,
  imports: [
    CommonModule,
    GlobalButtonComponent,
    AvatarModule,
    AvatarGroupModule,
    SidebarModule,
    MenuItemComponent,
    MenuModule,
    ButtonModule,
    MenuModule,
    OverlayPanelModule,
    OverlayNotificationsComponent,
  ],
  templateUrl: './navigation-bar-movil.component.html',
  styleUrl: './navigation-bar-movil.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class NavigationBarMovilComponent {
  @ViewChild('op') overlayPanel!: OverlayPanel;
  private readonly _usersService = inject(UsersService).currentUser();
  public sidebarVisible: boolean = false;
  public items!: SidebarMenuItem[];
  public itemsOptions: MenuItem[] | undefined;
  public options: MenuItem[] | undefined;
  private readonly menuService = inject(MenuService);
  private readonly router = inject(Router);
  private readonly _authService = inject(AuthService);
  public currentUserRole = signal<UserRole | undefined>(undefined);
  readonly UserRole = UserRole;
  public showNotification = signal<boolean>(false);

  ngOnInit(): void {
    this.currentUserRole.set(this._usersService.role_value as UserRole);
    this.menuService.setMenuItems(this._usersService.role_value);
    this.menuService.getMenuItems().subscribe((menuItems) => {
      this.items = menuItems;
    });
    this.itemsOptions = [
      {
        label: $localize`Mas opciones`,
        items: [
          {
            label: $localize`Sitio web publico`,
            icon: 'pi pi-objects-column',
            command: () => {
              this.router.navigate(['/admin/public-website']);
            },
          },
          {
            label: $localize`Configuración del sistema`,
            icon: 'pi pi-cog',
            command: () => {
              this.router.navigate(['/admin/config-system']);
            },
          },
        ],
      },
    ];
    this.options = [
      {
        label: $localize`Mi perfil`,
        icon: 'pi pi-user',
        command: () => this.goToProfile(),
      },
      {
        label: $localize`Cerrar sesión`,
        icon: 'pi pi-sign-out',
        command: () => this._authService.logout(),
      },
    ];
  }

  goToProfile() {
    console.log('Profile');
  }

  trackByFn(index: number, item: SidebarMenuItem) {
    return item.id;
  }

  public onHide() {
    document.body.classList.remove('no-scroll');
  }

  show(event: Event) {
    this.overlayPanel.toggle(event);
    if (this.overlayPanel.overlayVisible) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
}
